import { defineRouting } from 'next-intl/routing';
import { ALL_LOCALES, DEFAULT_LOCALE } from './locales';

// The locale set is the same for every brand, because this module is evaluated
// in the browser as well — see the note in `./locales.ts`. Whether a brand
// serves a locale is enforced server-side in `proxy.ts`.
export const routing = defineRouting({
  locales: ALL_LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: 'as-needed',
  // hreflang is owned by `buildPageMetadata` alone (10.02.01 § AC 4). Left on
  // (next-intl's default), the middleware adds a second, contradicting set as a
  // `Link:` response header: built from `ALL_LOCALES` and the incoming `Host`,
  // it advertises bare `de`/`fr` instead of the regional tags, the internal
  // `lokal.<brand>` origin instead of the canonical one, an `/fr/` URL the
  // proxy 404s on every brand but `.ch`, and an `x-default` the spec rules out.
  // The `.ch` de/fr pair it happens to get right is a guess — it reuses the
  // German path, and `page.slug` is localized; the real pair comes from
  // `localizedPaths` when the CH migration wires it.
  alternateLinks: false,
});
